



























import { Component, Inject } from 'vue-property-decorator';
import GraduationHatIcon from '@/components/Helper/Icon/Svg/GraduationHatIcon.vue';
import LessonBaseMixin from '@/components/ViewComponent/ELearning/lesson-base-mixin';
import TestIntroduce from '@/components/ViewComponent/ELearning/DoingTest/TestIntroduce.vue';
import { LessonTestQuestionEntity } from '@/entities/lesson-test-question.entity';
import LessonTestQuestionService from '@/services/lesson-test-question.service';
import { UseService } from '@/services/service';
import QuestionContent from '@/components/ViewComponent/ELearning/DoingTest/QuestionContent.vue';
import LessonTestResultService from '@/services/lesson-test-result.service';
import { LessonTestResultAnswerEntity } from '@/entities/lesson-test-result-answer.entity';
import { LessonTestResultEntity } from '@/entities/lesson-test-result.entity';
import LessonTestResultAnswerService from '@/services/lesson-test-result-answer.service';

@Component<DoingTest>({
  components: { QuestionContent, TestIntroduce, GraduationHatIcon },
})
export default class DoingTest extends LessonBaseMixin {
  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => any;

  @UseService(LessonTestQuestionService)
  questionService: LessonTestQuestionService;

  @UseService(LessonTestResultService)
  resultService: LessonTestResultService;

  @UseService(LessonTestResultAnswerService)
  resultAnswerService: LessonTestResultAnswerService;

  questions: LessonTestQuestionEntity[] = [];

  answers: LessonTestResultAnswerEntity[] = [];

  resultRecord: LessonTestResultEntity = null;

  currentQuestionIndex: number = null;

  get currentQuestion(): LessonTestQuestionEntity {
    return this.questions[this.currentQuestionIndex];
  }

  get hasNextQuestion(): boolean {
    return this.currentQuestionIndex < this.questions.length - 1;
  }

  async mounted(): Promise<void> {
    this.questions = await this.questionService.getManyByLessonId(this.lessonId);
    // this.currentQuestionIndex = this.questions.reduce<number>(
    //   (currentQuestionIndex, question, index) => {
    //     if (question.answer) {
    //       return index;
    //     }
    //     return currentQuestionIndex;
    //   },
    //   null,
    // );
  }

  async startDoingTest(): Promise<void> {
    await this.resultService.createOne({
      lessonId: this.lessonId,
    });
    this.currentQuestionIndex = 0;
  }

  async nextQuestion(): Promise<void> {
    if (this.currentQuestionIndex + 1 < this.questions.length) {
      this.currentQuestionIndex += 1;
    } else {
      await this.resultService.completeLessonTest(this.lessonId);
      await this.$router.push(`/e-learning/result/${this.lessonId}`);
    }
  }
}
